export default {
  NAVIGATION: {
    SERVICES: 'Dienste',
    SERVICE_SUBMISSIONS: 'Dienst Submissions',
    ALL_INCLUSIVE_SERVICES: 'Rundum Sorglos Dienste',
    TIER_SERVICES: 'Dienste nach Dringlichkeit',
    SERVICEAREAS: 'Dienstgebiete',
    USERS: 'Nutzer',
    INSURANCES: 'Versicherungen',
    ACCOUNTING: 'Buchhaltung',
    REPORTING: 'Reporting',
    LOGISTICS_HUB: 'Logistik Hub',
  },
  EXCEPTIONS: {
    HEADLINE: 'Es ist ein Fehler aufgetreten.',
    DESCRIPTION: 'Der folgende Fehler ist aufgetreten: ',
    OVERLAPPING_SERVICE_OPERATOR: 'Der Vertreter ist bereits für einen anderen Dienst in diesem Zeitraum eingeteilt.',
    OVERLAPPING_SERVICE_SUBSTITUTE: 'Sie sind bereits für einen anderen Dienst in diesem Zeitraum eingeteilt.',
    SPECIALIZATION_REQUIRED: 'Wir konnten Ihre Facharzturkunde noch nicht verifizieren und Sie haben sich auf einen Dienst in einem Bundesland beworden, in dem nur noch Fachärzte Bereitschaftsdienste vertreten dürfen.',
    SPECIALIZATION_MISMATCH: 'Ihr Fachgebiet entspricht nicht den Anforderungen des Dienstes.',
    CLOSE: 'Schließen',
  },
  SUDO_MODE: {
    BUTTON: 'Sudo Mode',
    WARNING: 'Sudo Mode Aktiv',
  },
  ORDER_CONFIRMATION: {
    GENERATE_ORDER_CONFIRMATION: 'Auftragsbestätigung Erzeugen',
    GENERATE_ORDER_SUMMARY: 'Auftragsübersicht Erzeugen',
    CLOSE: 'Schließen',
    TITLE: 'Auftragsbestätigung',
    VERIFY: 'Bitte schicken Sie die Auftragsbestätigung an:',
    MAIL: 'Mailadresse:',
    OR: 'oder',
    FAX: 'Faxnummer:',
    PERIOD: 'Zeitraum:',
    SERVICE_AREA: 'Dienstgebiet:',
    SUBTITLE: 'Anbei die Liste der Dienste, welche wir in Ihrem Auftrag zur Ausschreibung vorsehen würden.',
    SUBTITLE2: 'Wir bitten Sie, diese Liste auf Vollständigkeit und Richtigkeit zu prüfen.',
    ESTABLISHMENT_NAME: 'Betriebstätte',
    ESTABLISHMENT_ADDRESS: 'Adresse:',
    FROM: 'Von',
    TO: 'Bis',
    LENGTH: 'Dauer',
    SECONDARY_SERVICE_AREA: 'Dienstgebiet',
    TYPE: 'Typ',
    BREAK_BETWEEN: 'Pause zwischen',
  },
  ORDER_SUMMARY: {
    DOWNLOAD: 'Auftragsübersicht runterladen',
    INFO: 'Bitte benutzen Sie bei jedem Dienst das Kartenlesegerät des Kunden, wenn vorhanden. Ansonsten kann es zu Verzögerungen bezüglich der Auszahlung Ihres Honorars kommen.',
    DETAILS: 'Dienste im Detail',
    FROM: 'Von',
    TO: 'Bis',
    TITLE: 'Auftragsübersicht',
  },
  EVENT_LOGS: {
    HEADING: 'Event Log',
    TOGGLE: 'Event Log',
    EVENT_DESCRIPTION: {
      UPDATE_SERVICE: 'hat folgendes geändert:\n{details}',
      UPDATE_SERVICE_LOGISTICS: 'hat den Status auf {status} geändert',
    },
    EVENT_DESCRIPTION_LABELS: {
      kind: 'Dienstart',
      start: 'Dienststart',
      end: 'Dienstende',
      serviceBreakStart: 'Pause von',
      serviceBreakEnd: 'Pause bis',
      regularFeeMin: 'Mindesthonorar',
      regularFeeMax: 'Maximales Honorar',
      regularFeeCurrent: 'Aktuelles Honorar',
      kv_share_rate_m: 'Notfallscheinbeteiligung',
      kv_share_rate_o: 'Notfallscheinbeteiligung',
      state_insured_patient_count: 'Anzahl Gesetztlich Versicherte',
      private_patient_count: 'Anzahl Private Versicherte',
      necropsy_count: 'Anzahl Totenscheine',
      consultation_via_telephone_count: 'Anzahl Telefonischer Beratungen',
      cardreader_info: 'Kartenlesegerät',
      medical_documents_info: 'Medizinische Dokumente',
      misc_info: 'Sonstiges',
    },
    EVENT_TYPES: {
      update_service_logistics: 'Logistikstatus aktualisiert',
      cancel_service: 'Dienst storniert',
      remove_cancel_service: 'Wiederzugewiesen',
      send_notice_contract_documents: 'Dienstvertretungsvertrag und Tauschmeldung verschickt',
      user_registered: 'Nutzer hat sich registriert',
      update_profile: 'Profil aktualisiert',
      partner_role_request: 'Rolle "Kunde" festgelegt',
      substitute_role_request: 'Rolle "Vertreter" festgelegt',
      update_subsitute: 'Vertreterdaten aktualisiert',
      create_application: 'Bewerbung hinzugefügt',
      create_assignment: 'Dienst vergeben',
      revoke_application: 'Bewerbung gelöscht',
      revoke_assignment: 'Dienstzuweisung gelöscht',
      message_read: 'Nachricht gelesen',
      create_office_service: 'Sitzdienst angelegt',
      create_mobile_service: 'Fahrdienst angelegt',
      conclude_service: 'Dienst abgeschlossen',
      substitute_verified: 'Vertreter verifiziert',
      update_service: 'Dienst aktualisiert',
    },
  },
  TAB_LABELS: {
    OPERATOR_SERVICES: 'Dienstverwaltung',
    OPERATOR_SERVICESUBMISSIONS: 'Dienst Submissions',
    OPERATOR_ALLINCLUSIVE_SERVICES: 'Rundum-Sorglos Dienste',
    OPERATOR_TIER_SERVICES: 'Dienste nach Dringlichkeit',
    OPERATOR_SERVICEAREAS: 'Dienstgebiete',
    OPERATOR_SINGLE_SERVICEAREA: 'Dienstgebiet',
    OPERATOR_USERS: 'Nutzerverwaltung',
    OPERATOR_INSURANCES: 'Versicherungen',
    OPERATOR_ACCOUNTING: 'Buchhaltung',
    OPERATOR_REPORTING_REGISTERED_SERVICES: 'Reporting Eingetragene Dienste',
    OPERATOR_REPORTING_REGISTERED_USERS: 'Reporting Registrierte Nutzer',
    OPERATOR_SINGLE_USER: 'Nutzer',
    OPERATOR_SINGLE_SERVICE: 'Dienst',
    OPERATOR_LOGISTICS_HUB: 'Logistik Hub',
  },
  CLOSE_TAB: 'Tab schließen',
  TABLE: {
    ROWS_PER_PAGE: 'Zeilen pro Seite',
    NO_DATA: 'Keine Daten geladen',
    SEPARATOR: 'von',
  },
  CONFIRM: {
    YES: 'Ja',
    NO: 'Nein',
  },
};
